import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const MedicalChart = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M21 2H11C8.243 2 6 4.243 6 7V25C6 27.757 8.243 30 11 30H21C23.757 30 26 27.757 26 25V7C26 4.243 23.757 2 21 2ZM12 4H20V5C20 5.551 19.551 6 19 6H13C12.449 6 12 5.551 12 5V4ZM24 25C24 26.654 22.654 28 21 28H11C9.346 28 8 26.654 8 25V7C8 5.696 8.836 4.585 10 4.172V5C10 6.654 11.346 8 13 8H19C20.654 8 22 6.654 22 5V4.172C23.164 4.585 24 5.696 24 7V25Z" />
		<path d="M21.832 18.445L17.832 12.445C17.653 12.177 17.347 12 17 12C16.515 12 16.111 12.345 16.02 12.804L14.493 20.437L11.832 16.446C11.653 16.178 11.347 16.001 11 16.001C10.448 16.001 10 16.449 10 17.001C10 17.206 10.062 17.397 10.168 17.556L14.168 23.556C14.347 23.824 14.653 24.001 15 24.001C15.485 24.001 15.889 23.655 15.98 23.197L17.507 15.564L20.168 19.555C20.347 19.823 20.653 20 21 20C21.552 20 22 19.552 22 19C22 18.795 21.938 18.604 21.832 18.446V18.445Z" />
	</svg>
);

export default MedicalChart;
